import axios from 'axios';
import UserActions from 'flux/actions/UserActions';
import { getClientId } from 'shared/data/helpers/ApiClient';
import { isRemoteTeleprompter } from 'main/components/show/cuesheet/cuesheetViewHelper';
import _ from 'underscore';
import 'shared/lib/intercom';

window.addEventListener('unhandledrejection', (event) => {
  console.log('unhandled rejection', event);
});

/**
 * General app initialization stuff..
 *
 */

/**
 * Generate a unique client ID
 *
 * What's happening?
 *
 * We're sending along a unique client ID so that originators of changes don't process realtime requests they originated.
 */
const clientId = getClientId();

/**
 * Set the client ID
 */
if (window.location.href.indexOf('guest') === -1 || isRemoteTeleprompter())
  UserActions.setClientId(clientId);

/**
 * Add an HTTP interceptor that attaches the clientId to each request
 */

axios.interceptors.request.use((config) =>
  _addCfgData(config, 'clientId', clientId),
);

/**
 * Set a property on the config data object
 *
 * @param cfg
 * @param k
 * @param v
 * @returns {*}
 */
const _addCfgData = (cfg, k, v) => {
  if (!cfg.data) cfg.data = {};
  cfg.data[k] = v;
  return cfg;
};

const debouncedLoadFromSession = _.debounce(
  UserActions.loadFromSession,
  1000, // dont call this function more than once per second
  true, // call this immediately instead of waiting til the end of 1 second
);

/**
 * Add interceptors that check if all requests are 401s, if so, try to get the user from session, which will trigger a logout if it fails
 */
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    let statusCode;
    if (error.response && error.response.status) {
      statusCode = error.response.status;
    } else if (error && error.data) {
      statusCode = error.data.statusCode;
    }

    error.status = statusCode;

    if (statusCode === 401) {
      debouncedLoadFromSession();
    }

    return Promise.reject(error);
  },
);
